"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetInspections = exports.deleteManyInspections = exports.deletedOneInspection = exports.updatedManyInspections = exports.updatedOneInspection = exports.gotManyInspections = exports.gotOneInspection = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOneInspection = gotOne;
exports.gotManyInspections = gotMany;
exports.updatedOneInspection = updatedOne;
exports.updatedManyInspections = updatedMany;
exports.deletedOneInspection = deletedOne;
exports.deleteManyInspections = deleteMany;
exports.resetInspections = reset;
//# sourceMappingURL=actions.js.map